export default __webpack_public_path__ + "static/media/ProductsList_PC_img4_En.65cad885.webp";